import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ResidentData, ResidentHistoryRecord } from 'src/lib/fliko/models/person/resident.data';
import { Nullish } from 'src/lib/fliko/types/typeish.type';
import { DatabaseService } from 'src/app/shared/services/database.service';

@Injectable({ providedIn: 'root' })
export class ResidentService {
  constructor(private dbSrv: DatabaseService) {}

  /**
   * @path /resident/$estateId/
   * @key id
   */
  private get resident() {
    return this.dbSrv.estateFactory.getCollection<ResidentData>('resident/$eId');
  }

  public getResidents$(): Observable<ResidentData[]> {
    return this.resident.getList();
  }

  public getResidentsMap$(): Observable<Map<string, ResidentData>> {
    return this.resident.getMap();
  }

  public getResident$(id: string): Observable<ResidentData | Nullish> {
    return this.resident.getElement(id);
  }

  public setResident(resident: ResidentData): Promise<void> {
    return this.resident.setElement(resident.id, resident);
  }

  public updateResident(resident: ResidentData): Promise<void> {
    return this.resident.updateElement(resident.id, resident);
  }

  /**
   * @param {string} residentId
   * @path /residentHistoryRecord/$estateId/$residentId/
   * @key id
   */
  private residentHistory = (residentId: string) =>
    this.dbSrv.estateFactory.getCollectionReadOnly<ResidentHistoryRecord>(`residentHistoryRecord/$eId/${residentId}`);

  public getResidentHistoryRecords$(id: string): Observable<ResidentHistoryRecord[]> {
    return this.residentHistory(id).getList();
  }
}
